'use strict';/* global define */define('modules/custom-forms/services/custom-form/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Return the ngResource object
   *
   * @tested
   */// @ngInject
factory.$inject = ["$resource", "API_ENDPOINT"];
function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
return $resource(API_ENDPOINT+'feedback-processes/:feedbackPeriodId/form-revisions/:revisionId',{feedbackPeriodId:'@feedbackPeriodId',revisionId:'@revisionId'},{update:{method:'PATCH'}});}module.exports=factory;});
